const osceola = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854924/KTC-Images/osceola_sut5jr.png`;
const finishedProject = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854945/KTC-Images/Geneva_Driveway_Finished_yvvbbk.jpg`;

export const homeObjOne = {
    id: 'about',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: '40+ Years Experience',
    headline: 'Servicing Orange and Osceola County, FL',
    description: 'Based out of Osceola County, we are a locally owned and operated company. Check us out on ',
    buttonLabel: 'Get started',
    imgStart: false,
    img: osceola,
    alt: 'Osceola County',
    dark: false,
    primary: true,
    darkText: true,
    hasLink: true
};

export const homeObjTwo = {
    id: 'contact',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Give Us a Call',
    headline: '(407)-301-5947',
    description: "Thinking of starting a new project? Give us a call to get a free estimate.",
    buttonLabel: 'Start Now',
    imgStart: false,
    img: finishedProject,
    alt: 'Cement Being Smoothed',
    dark: false,
    primary: false,
    darkText: true,
    hasLink: false
};